export default "__VITE_ASSET__vUAevk9v__"